import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';

import * as actions from '../actions';
import * as actionCreators from '../action-creators';
import { mergeMap } from 'rxjs/operators';
import { Actions } from '../../actions';
import * as auth from '@webapp/sdk/auth';
import { NoOp } from '../../ui/action-creators';
import { setLocalStorageItem } from '@webapp/utils/localstorage';
import { rudderIdentify } from '@webapp/utils/rudderstack/init';

export const loginEpic = (action$: Observable<Actions>) =>
  action$.pipe(
    ofType<Actions, actionCreators.LoginUser>(actions.LOGIN_USER),
    mergeMap((action) =>
      auth.login(action.data).then(async (loginData) => {
        const provider = action.data.phone
          ? 'Phone'
          : action.data.email
          ? 'Email'
          : undefined;
        setLocalStorageItem('provider', provider);

        if (loginData) {
          await rudderIdentify(loginData.attributes.sub, {
            type: 'User Signed in (Identify)',
            full_name: `${loginData.attributes?.given_name} ${loginData.attributes?.family_name}`,
            email_addresses: loginData.attributes?.email,
          });
        }

        return new NoOp();
      })
    )
  );
